import { SET_USER, CLEAR_USER, CARD_DETAILS_SUCCESS, SET_TRANSACTIONS, CLEAR_TRANSACTIONS, RESERVED_PAYMENT_SUCCESS, RESERVED_GIFTCARD_PAYMENT_SUCCESS, FORGOT_PASSWORD_USER_DATA, FORGOT_PASSWORD_USER_CLEAR_DATA } from './types';

const initialState = {
  user: null,
  userForgotData: null,
  transactions: [],
  reservedBooking: {},
  reservedGiftResult: {},
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case SET_USER: {
      return {
        ...state,
        user: payload.user
      };
    }
    case FORGOT_PASSWORD_USER_DATA: {
      return {
        ...state,
        userForgotData: payload.data
      };
    }

    case CARD_DETAILS_SUCCESS: {
      // giftCardBalance and cardNumber moved out of the user response (CD-2089);
      // merging keeps every existing user.* consumer working unchanged
      if (!state.user) return state;

      return {
        ...state,
        user: { ...state.user, ...payload.cardDetails }
      };
    }

    case CLEAR_USER: {
      return {
        ...state,
        user: null
      };
    }

    case FORGOT_PASSWORD_USER_CLEAR_DATA: {
      return {
        ...state,
        userForgotData: null
      };
    }

    case SET_TRANSACTIONS: {
      return {
        ...state,
        transactions: payload.transactions
      };
    }

    case CLEAR_TRANSACTIONS: {
      return {
        ...state,
        transactions: []
      };
    }

    case RESERVED_PAYMENT_SUCCESS: {
      return {
        ...state,
        reservedBooking: payload.reservedResult
      };
    }

    case RESERVED_GIFTCARD_PAYMENT_SUCCESS: {
      return {
        ...state,
        reservedGiftResult: payload.reservedGiftResult
      };
    }

    default: {
      return state;
    }
  }
}
